import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Card from "components/card";
import SectionHeader from "components/section/SectionHeader";
import { connect } from "react-redux";
import { getTrainingClassDetails } from "../../../redux/trainingclass/trainingClassState";
import TrainingClassTab from "./components/TrainingClassTab";
import { useLocation } from "react-router-dom";
import TrainingClassCard from "./components/TrainingClassCard";

const ViewTrainingClass = ({ getRecord, recordData }) => {
  const { classeId } = useParams();
  const location = useLocation();

  const startTab = location.pathname.includes("/training-class-modules")
    ? "training-class-modules"
    : location.pathname.includes("/training-class-participants")
    ? "training-class-participants"
    : location.pathname.includes("/training-class-results")
    ? "training-module-results"
    : "training-class-modules";

  useEffect(() => {
      getRecord(classeId);
  }, [classeId, getRecord]);

  return (
    <Card className="grid h-full grid-cols-1 gap-6">
      <TrainingClassCard recordData={recordData} isLink={false}/>
      <TrainingClassTab recordId={classeId} startTab={startTab} />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.trainingClass.trainingClassDetails?.data,
  requesting: state.trainingClass.trainingClassDetails?.requesting,
	success: state.trainingClass.trainingClassDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getTrainingClassDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTrainingClass);
